/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppSettingsRouteRouteImport } from './routes/_app/settings.route'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings.index'
import { Route as AppProgramsIndexRouteImport } from './routes/_app/programs.index'
import { Route as AppOrdersIndexRouteImport } from './routes/_app/orders.index'
import { Route as AppClientsIndexRouteImport } from './routes/_app/clients.index'
import { Route as AppAppointmentsIndexRouteImport } from './routes/_app/appointments.index'
import { Route as AppSettingsPaymentRouteImport } from './routes/_app/settings.payment'
import { Route as AppSettingsLogsRouteImport } from './routes/_app/settings.logs'
import { Route as AppSettingsGoogleMeetRouteImport } from './routes/_app/settings.google-meet'
import { Route as AppSettingsEmailRouteImport } from './routes/_app/settings.email'
import { Route as AppSettingsAvailabilityRouteImport } from './routes/_app/settings.availability'
import { Route as AppClientsClientIdRouteImport } from './routes/_app/clients.$clientId'
import { Route as AppProgramsProgramIdEditRouteImport } from './routes/_app/programs.$programId.edit'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSettingsRouteRoute = AppSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppProgramsIndexRoute = AppProgramsIndexRouteImport.update({
  id: '/programs/',
  path: '/programs/',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersIndexRoute = AppOrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => AppRoute,
} as any)
const AppClientsIndexRoute = AppClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => AppRoute,
} as any)
const AppAppointmentsIndexRoute = AppAppointmentsIndexRouteImport.update({
  id: '/appointments/',
  path: '/appointments/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsPaymentRoute = AppSettingsPaymentRouteImport.update({
  id: '/payment',
  path: '/payment',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsLogsRoute = AppSettingsLogsRouteImport.update({
  id: '/logs',
  path: '/logs',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsGoogleMeetRoute = AppSettingsGoogleMeetRouteImport.update({
  id: '/google-meet',
  path: '/google-meet',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsEmailRoute = AppSettingsEmailRouteImport.update({
  id: '/email',
  path: '/email',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsAvailabilityRoute = AppSettingsAvailabilityRouteImport.update({
  id: '/availability',
  path: '/availability',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppClientsClientIdRoute = AppClientsClientIdRouteImport.update({
  id: '/clients/$clientId',
  path: '/clients/$clientId',
  getParentRoute: () => AppRoute,
} as any)
const AppProgramsProgramIdEditRoute =
  AppProgramsProgramIdEditRouteImport.update({
    id: '/programs/$programId/edit',
    path: '/programs/$programId/edit',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/settings': typeof AppSettingsRouteRouteWithChildren
  '/clients/$clientId': typeof AppClientsClientIdRoute
  '/settings/availability': typeof AppSettingsAvailabilityRoute
  '/settings/email': typeof AppSettingsEmailRoute
  '/settings/google-meet': typeof AppSettingsGoogleMeetRoute
  '/settings/logs': typeof AppSettingsLogsRoute
  '/settings/payment': typeof AppSettingsPaymentRoute
  '/appointments/': typeof AppAppointmentsIndexRoute
  '/clients/': typeof AppClientsIndexRoute
  '/orders/': typeof AppOrdersIndexRoute
  '/programs/': typeof AppProgramsIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/programs/$programId/edit': typeof AppProgramsProgramIdEditRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/clients/$clientId': typeof AppClientsClientIdRoute
  '/settings/availability': typeof AppSettingsAvailabilityRoute
  '/settings/email': typeof AppSettingsEmailRoute
  '/settings/google-meet': typeof AppSettingsGoogleMeetRoute
  '/settings/logs': typeof AppSettingsLogsRoute
  '/settings/payment': typeof AppSettingsPaymentRoute
  '/appointments': typeof AppAppointmentsIndexRoute
  '/clients': typeof AppClientsIndexRoute
  '/orders': typeof AppOrdersIndexRoute
  '/programs': typeof AppProgramsIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/programs/$programId/edit': typeof AppProgramsProgramIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/_app/settings': typeof AppSettingsRouteRouteWithChildren
  '/_app/clients/$clientId': typeof AppClientsClientIdRoute
  '/_app/settings/availability': typeof AppSettingsAvailabilityRoute
  '/_app/settings/email': typeof AppSettingsEmailRoute
  '/_app/settings/google-meet': typeof AppSettingsGoogleMeetRoute
  '/_app/settings/logs': typeof AppSettingsLogsRoute
  '/_app/settings/payment': typeof AppSettingsPaymentRoute
  '/_app/appointments/': typeof AppAppointmentsIndexRoute
  '/_app/clients/': typeof AppClientsIndexRoute
  '/_app/orders/': typeof AppOrdersIndexRoute
  '/_app/programs/': typeof AppProgramsIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/programs/$programId/edit': typeof AppProgramsProgramIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/settings'
    | '/clients/$clientId'
    | '/settings/availability'
    | '/settings/email'
    | '/settings/google-meet'
    | '/settings/logs'
    | '/settings/payment'
    | '/appointments/'
    | '/clients/'
    | '/orders/'
    | '/programs/'
    | '/settings/'
    | '/programs/$programId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/clients/$clientId'
    | '/settings/availability'
    | '/settings/email'
    | '/settings/google-meet'
    | '/settings/logs'
    | '/settings/payment'
    | '/appointments'
    | '/clients'
    | '/orders'
    | '/programs'
    | '/settings'
    | '/programs/$programId/edit'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/_app/settings'
    | '/_app/clients/$clientId'
    | '/_app/settings/availability'
    | '/_app/settings/email'
    | '/_app/settings/google-meet'
    | '/_app/settings/logs'
    | '/_app/settings/payment'
    | '/_app/appointments/'
    | '/_app/clients/'
    | '/_app/orders/'
    | '/_app/programs/'
    | '/_app/settings/'
    | '/_app/programs/$programId/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/programs/': {
      id: '/_app/programs/'
      path: '/programs'
      fullPath: '/programs/'
      preLoaderRoute: typeof AppProgramsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders/': {
      id: '/_app/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof AppOrdersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clients/': {
      id: '/_app/clients/'
      path: '/clients'
      fullPath: '/clients/'
      preLoaderRoute: typeof AppClientsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/appointments/': {
      id: '/_app/appointments/'
      path: '/appointments'
      fullPath: '/appointments/'
      preLoaderRoute: typeof AppAppointmentsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/payment': {
      id: '/_app/settings/payment'
      path: '/payment'
      fullPath: '/settings/payment'
      preLoaderRoute: typeof AppSettingsPaymentRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/logs': {
      id: '/_app/settings/logs'
      path: '/logs'
      fullPath: '/settings/logs'
      preLoaderRoute: typeof AppSettingsLogsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/google-meet': {
      id: '/_app/settings/google-meet'
      path: '/google-meet'
      fullPath: '/settings/google-meet'
      preLoaderRoute: typeof AppSettingsGoogleMeetRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/email': {
      id: '/_app/settings/email'
      path: '/email'
      fullPath: '/settings/email'
      preLoaderRoute: typeof AppSettingsEmailRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/availability': {
      id: '/_app/settings/availability'
      path: '/availability'
      fullPath: '/settings/availability'
      preLoaderRoute: typeof AppSettingsAvailabilityRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/clients/$clientId': {
      id: '/_app/clients/$clientId'
      path: '/clients/$clientId'
      fullPath: '/clients/$clientId'
      preLoaderRoute: typeof AppClientsClientIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/programs/$programId/edit': {
      id: '/_app/programs/$programId/edit'
      path: '/programs/$programId/edit'
      fullPath: '/programs/$programId/edit'
      preLoaderRoute: typeof AppProgramsProgramIdEditRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppSettingsRouteRouteChildren {
  AppSettingsAvailabilityRoute: typeof AppSettingsAvailabilityRoute
  AppSettingsEmailRoute: typeof AppSettingsEmailRoute
  AppSettingsGoogleMeetRoute: typeof AppSettingsGoogleMeetRoute
  AppSettingsLogsRoute: typeof AppSettingsLogsRoute
  AppSettingsPaymentRoute: typeof AppSettingsPaymentRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteRouteChildren: AppSettingsRouteRouteChildren = {
  AppSettingsAvailabilityRoute: AppSettingsAvailabilityRoute,
  AppSettingsEmailRoute: AppSettingsEmailRoute,
  AppSettingsGoogleMeetRoute: AppSettingsGoogleMeetRoute,
  AppSettingsLogsRoute: AppSettingsLogsRoute,
  AppSettingsPaymentRoute: AppSettingsPaymentRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteRouteWithChildren =
  AppSettingsRouteRoute._addFileChildren(AppSettingsRouteRouteChildren)

interface AppRouteChildren {
  AppSettingsRouteRoute: typeof AppSettingsRouteRouteWithChildren
  AppClientsClientIdRoute: typeof AppClientsClientIdRoute
  AppAppointmentsIndexRoute: typeof AppAppointmentsIndexRoute
  AppClientsIndexRoute: typeof AppClientsIndexRoute
  AppOrdersIndexRoute: typeof AppOrdersIndexRoute
  AppProgramsIndexRoute: typeof AppProgramsIndexRoute
  AppProgramsProgramIdEditRoute: typeof AppProgramsProgramIdEditRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppSettingsRouteRoute: AppSettingsRouteRouteWithChildren,
  AppClientsClientIdRoute: AppClientsClientIdRoute,
  AppAppointmentsIndexRoute: AppAppointmentsIndexRoute,
  AppClientsIndexRoute: AppClientsIndexRoute,
  AppOrdersIndexRoute: AppOrdersIndexRoute,
  AppProgramsIndexRoute: AppProgramsIndexRoute,
  AppProgramsProgramIdEditRoute: AppProgramsProgramIdEditRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
